import React from 'react';
import DescribeRestaurant from './DescribeRestaurant';

class Locations extends React.Component {
  render() {
    let locationsList = this.props.list;
    locationsList = locationsList
      .filter(e => e.lavu_togo_name.toLowerCase() === this.props.locationName.toLowerCase())
      .concat(
        locationsList
          .filter(e => e.lavu_togo_name.toLowerCase() !== this.props.locationName.toLowerCase())
          .sort((a, b) => a.lavu_togo_name.localeCompare(b.lavu_togo_name))
      );
    return locationsList ? (
      <div className="restaurant-locations">
        {this.props.showMultipleLocations === '1' ? (
          <div>
            {locationsList.map((item, key) => (
              <div key={`loactions-key-${key}`}>
                {this.props.locationName.toLowerCase() === item.lavu_togo_name.toLowerCase() ? (
                  <DescribeRestaurant
                    handleOrderType={(data, type) =>
                      this.props.handleOrderType(data, type)
                    }
                    key={`restaurant-key-${key}`}
                    data={item}
                    actions={this.props.actions}
                    modeOfOrder={this.props.modeOfOrder}
                    activeRestaurantLocation={
                      this.props.activeRestaurantLocation
                    }
                    isOne={locationsList.length}
                    showMultipleLocations={this.props.showMultipleLocations}
                  />
                ) : null}
              </div>
            ))}
          </div>
        ) : (
          <div>
            {locationsList.map((item, key) => (
              <DescribeRestaurant
                handleOrderType={(data, type) =>
                  this.props.handleOrderType(data, type)
                }
                key={`restaurant-key-${key}`}
                data={item}
                actions={this.props.actions}
                modeOfOrder={this.props.modeOfOrder}
                activeRestaurantLocation={this.props.activeRestaurantLocation}
                isOne={locationsList.length}
                showMultipleLocations={this.props.showMultipleLocations}
              />
            ))}
          </div>
        )}
      </div>
    ) : null;
  }
}

export default Locations;



// WEBPACK FOOTER //
// ./src/views/orderType/components/Locations.jsx